<template>
  <div class="members">
    <div class="page-header">
      <v-layout row align-center>
        <v-icon x-large color="primary">mdi-account-multiple</v-icon>
        <h1 class="page-title">Members</h1>
      </v-layout>
    </div>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-data-table
          :hide-default-footer="hideFooter"
          :headers="headers"
          :items="members"
          :items-per-page="itemsPerPage"
          :search="search"
        >
          <template v-slot:header>
            <v-row>
              <v-col cols="12">
                <div v-if="priviledged" class="add-button">
                  <v-btn outlined @click="onEdit(0)">
                    <v-icon left>mdi-plus</v-icon>Add
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </template>
          <template v-slot:item.edit="{ item }">
            <div v-if="priviledged" class="button">
              <v-btn outlined @click="onEdit(item.memberId)">
                <v-icon left>mdi-pencil</v-icon>Edit
              </v-btn>
            </div>
          </template>
          <template v-slot:item.delete="{ item }">
            <div v-if="priviledged" class="button">
              <v-btn outlined @click="onDelete(item.memberId)">
                <v-icon left>mdi-delete</v-icon>Delete
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">
            Delete the selected<br />member?
          </v-card-title>
          <v-card-text>{{ title }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined text @click="dialog = false">No</v-btn>
            <v-btn outlined text @click="deleteMember">Yes</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <statusalert ref="alert" returnUrl="/faq"></statusalert>
  </div>
</template>

<script>
import MembersService from '../../services/api/MembersService'
import store from '@/store/index.js'
import router from '@/router/index.js'
import statusalert from '../../components/StatusAlert'
import authorizedMixin from '../../mixins/authorizedMixin'

export default {
  name: 'Members',
  mixins: [authorizedMixin],

  components: {
    statusalert
  },
  store: store,

  data() {
    return {
      dialog: false,
      headers: [
        {
          text: '',
          align: 'start',
          sortable: true,
          value: 'edit'
        },
        {
          text: '',
          align: 'start',
          sortable: true,
          value: 'delete'
        },
        {
          text: 'Lastname',
          align: 'start',
          sortable: true,
          value: 'lastname'
        },
        {
          text: 'Firstname',
          align: 'start',
          sortable: true,
          value: 'firstname'
        }
      ],
      hideFooter: true,
      itemsPerPage: 9999,
      members: [],
      memberId: 0,
      search: '',
      title: ''
    }
  },
  created() {
    this.fetch()
  },
  computed: {
    priviledged() {
      return (
        this.$store.getters.getAdministrator || this.$store.getters.getProShop
      )
    }
  },
  methods: {
    deleteMember() {
      this.dialog = false
      if (this.memberId > 0) {
        MembersService.delete(this.memberId)
          .then(result => {
            this.result = {
              isValid: true,
              statusCode: result.status,
              errors: ['Deleted member']
            }
          })
          .catch(error => {
            console.log(error)
            this.result = {
              isValid: false,
              statusCode: 404,
              errors: ['Failed to delete member']
            }
          })
          .finally(() => {
            store.commit('notLoading')
            this.$refs.alert.displayResult(this.result)
            this.fetch()
          })
      }
    },

    fetch() {
      store.commit('isLoading')
      this.members = []
      MembersService.get()
        .then(members => {
          this.members = members
          this.sort()
        })
        .catch(error => console.log(error))
        .finally(() => {
          store.commit('notLoading')
        })
    },

    onEdit(memberId) {
      router.push('/admin/member/edit/' + memberId)
    },

    onDelete(memberId) {
      this.dialog = true
      const member = this.members.find(n => n.memberId === memberId)
      this.title = ''
      this.memberId = 0
      if (member) {
        this.memberId = memberId
        this.title = member.lastname + ', ' + member.firstname
      }
    },

    sort() {
      this.members.sort(function(a, b) {
        if (a.lastname === b.lastname) {
          return a.firstname < b.firstname
            ? -1
            : a.firstname > b.firstname
            ? 1
            : 0
        } else {
          return a.lastname < b.lastname ? -1 : 1
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.add-button {
  padding-left: 22px;
}
.button {
  padding: 5px;
}
</style>
